import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/checked-white.svg'


const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "content-facades" }
const _hoisted_3 = { class: "content-name-select" }
const _hoisted_4 = { class: "name-facade bold" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "content-checked"
}
const _hoisted_7 = { class: "price-facade bold" }
const _hoisted_8 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("label", { class: "label" }, "Select Facade", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.facades, (facade) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "facade-card",
          key: facade._id
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(facade.name), 1),
            (facade._id !== $setup.selectedFacadeId)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "badge select",
                  onClick: ($event: any) => ($setup.onSelectFacade(facade._id, facade.url, facade.name, facade.price))
                }, _toDisplayString($setup.getButtonLabel(facade._id)), 9, _hoisted_5))
              : _createCommentVNode("", true),
            (facade._id === $setup.selectedFacadeId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    class: "icon-checked",
                    src: _imports_0
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString($setup.formatPrice(facade.price)), 1),
          _createElementVNode("img", {
            class: "image-facade",
            src: facade.url,
            alt: facade.name
          }, null, 8, _hoisted_8)
        ]))
      }), 128))
    ])
  ]))
}